import createRound from "./internal/createRound";

// Number -> Number -> Number
const floor = createRound("floor");

export default floor;
